import { render } from "./AktuellesComponent.vue?vue&type=template&id=6e1170d9&scoped=true"
import script from "./AktuellesComponent.vue?vue&type=script&lang=js"
export * from "./AktuellesComponent.vue?vue&type=script&lang=js"

import "./AktuellesComponent.vue?vue&type=style&index=0&id=6e1170d9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e1170d9"]])

export default __exports__